import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  filesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    minHeight: 100,
  },
  filesContainerPageWrapper: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
    minHeight: 100,
  },
  uploadFileLabel: {
    width: '120px',
    minWidth: '120px',
    height: '100px',
    borderRadius: '4px',
    border: `1px dashed ${theme.palette.primary.main}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',

    '& svg': {
      color: theme.palette.primary.main,
    },
  },

  file: {
    border: '1px solid transparent',
    borderRadius: '4px',
    overflow: 'hidden',
    position: 'relative',
  },
  mainFileLabel: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: '2px 4px',
    borderTopLeftRadius: '4px',
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 1,
  },
  mainFile: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));
